import './App.css';
import React from 'react';
import { useState, useContext } from 'react';
import axios from 'axios';
import AppBarCustom from "./components/AppBarCustom";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import Footer from "./components/Footer";
import getLPTheme from "./getLPTheme";

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    // width: 400,
    bgcolor: 'background.paper',
    boxShadow: 24,
    maxWidth: '600px',
    p: 4,
    borderRadius: 2
};

function App(props) {

    const [isOpen, setOpen] = useState(false);

    const handleClose = () => {
        setOpen(false);
    }


    const lightTheme = createTheme(getLPTheme('light'));

    return (
        <ThemeProvider theme={lightTheme} >
            <div className="App">
                {/*<ThemeProvider theme={getLPTheme('light')}>*/}
                <AppBarCustom mode={'light'}/>
                    {props.children}
                <Footer/>
            </div>
        </ThemeProvider>
    );
}

export default App;

